import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/Location.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import List from "./styledComponents/Table/List";
import { Modal } from "antd";
import AddModal from "./styledComponents/Modal/AddModal";
import UpdateModal from "./styledComponents/Modal/UpdateModal";
import Loader from "../components/styled-components/loader/loader";
import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
import ViewModal from "./styledComponents/Modal/ViewModal";

import swal from "sweetalert";
import axios from "axios";

export const LocationofItems = (props) => {
  const cols = [
    {
      title: "Personal Item",
      dataIndex: "wish",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Location",
      dataIndex: "location",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "note",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                getSelectedRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedRow(record.id);
                          setDropdown(false);
                        }}>
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateModal(true);
                          setDropdown(false);
                        }}>
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewModal(true);
                        setDropdown(false);
                      }}>
                      View
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];
  const fields = [
    // {
    //   title: "Personal Item",
    //   type: "select",
    //   options: ["Abc", "Def","Others"],
    //   index: "PersonalItem"
    // },
    {
      title: "Location",
      type: "input",
      index: "Location",
    },
    {
      title: "Personal Item",
      type: "textarea",
      index: "PersonalWishes",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "Notes",
    },
  ];

  const update_fields = [
    // {
    //   title: "Personal Item",
    //   type: "select",
    //   options: ["Abc", "Def","Others"],
    //   index: "PersonalItem"
    // },
    {
      title: "Location",
      type: "input",
      index: "location",
    },
    {
      title: "Personal Item",
      type: "textarea",
      index: "wish",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "note",
    },
  ];
  const [itemsList, setItemsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [addData, setaddData] = useState({});
  const [updateObject, setUpdateObject] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [tooltipModal, setTooltipModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const handelCloseViewModal = () => {
    setShowViewModal(false);
  };

  useEffect(() => {
    console.log("calling api");
    getPersonalItems();
  }, []);
  const getPersonalItems = async () => {
    try {
      (async () => {
        setLoading(true);
        const ID = localStorage.getItem("accessId");
        let data = await DEATH_API.fetchPersonalItemLocation(ID);
        setLoading(false);
        if (data && data.data) {
          setItemsList(data.data);
        } else {
          setItemsList([]);
        }
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };

  const handlechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDocumentChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDocumentChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDatePickerChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRadioChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const SubmitUpdate = () => {
    console.log("updated object submit", updateObject);
    updatePersonalItem();
    handelCloseUpdateModal();
  };
  const submitData = () => {
    console.log("submit data", addData);
    createPersonalItem();
    handelCloseModal();
  };
  const handelCloseModal = () => {
    setShowModal(false);
  };
  const handelCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  const getSelectedRow = (idx) => {
    console.log("idx", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = itemsList.filter((row, index) => {
      return row.id == idx;
    });

    // get first and only element from list and store it in update object
    console.log("selectedRow", selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };
  const createPersonalItem = async (currentFormData) => {
    // check if already formData contains some data then initialize it with empty

    var arr = [addData];
    try {
      let data = arr;
      // this.props.handleLoader()
      setLoading(true);
      if (Array.isArray(data) && data.length > 0) {
        await DEATH_API.addPersonalItemLocation({
          personalItemLocationForm: data.map((item) => {
            return {
              // name: item.PersonalItem,
              location: item.Location,
              wish: item.PersonalWishes,
              note: item.Notes,
            };
          }),
        });
      }
      setLoading(false);
      getPersonalItems();
    } catch (error) {
      console.log(error);
      swal("Error!", "You data has not been saved!", "error");
      this.props.handleLoader();
    }
  };
  const updatePersonalItem = async () => {
    try {
      setLoading(true);
      let obj = {
        ...updateObject,
        location: updateObject.Location,
        wish: updateObject.wish,
        note: updateObject.note,
      };

      await DEATH_API.updatePersonalItemLocation(obj.id, obj);
      setLoading(false);
      getPersonalItems();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const deleteSelectedRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        // that.props.handleLoader()
        try {
          setLoading(true);
          await DEATH_API.deletePersonalItemLocation(idx);
          setLoading(false);

          const updatedRows = itemsList.filter((row, index) => {
            return index != idx - 1;
          });
          // setItemsList(updatedRows);
          getPersonalItems();
        } catch (error) {
          console.log("error in deleting Account asset form");
          console.log(error);
        }
        setTimeout(async () => {
          setLoading(true);
          swal("Deleted!", "Your file has been deleted.", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  return (
    <div>
      {" "}
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Personal Items Location</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              OK, we are not talking about buried treasure! -- - or are we? The
              point of this program feature is for the Plan Creator to be given
              an opportunity to list personal items that might not be found on a
              balance sheet. Comic books, gold bullion, heirloom jewelry,
              collectible car stored in a friend’s garage, are all potential
              candidates for secrecy and a desire to list separately.
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>
      {showModal && (
        <AddModal
          show={showModal}
          close={handelCloseModal}
          fields={fields}
          modalTitle="Add New Personal Items"
          handlechange={handlechange}
          submitData={submitData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
        />
      )}
      {showUpdateModal && (
        <UpdateModal
          show={showUpdateModal}
          close={handelCloseUpdateModal}
          fields={update_fields}
          modalTitle="Update Personal Items"
          handlechange={handleUpdatechange}
          submitData={SubmitUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          obj={updateObject}
        />
      )}
      {showViewModal && (
        <ViewModal
          show={showViewModal}
          close={handelCloseViewModal}
          fields={update_fields}
          modalTitle="View Personal Items"
          obj={updateObject}
        />
      )}
      <Style.MainHeading>
        {/* <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg> */}
        Location of Personal Items{" "}
        <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}></Style.HelpIcon>
      </Style.MainHeading>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Personal Items Location</Style.Title>
          {props.role !== "protrustee" && (
            <div>
              <Style.Button
                onClick={() => {
                  setShowModal(true);
                }}>
                +
              </Style.Button>
            </div>
          )}
        </Style.HealthCardHeader>
        <List cols={cols} rows={itemsList}></List>
      </Style.HealthCard>
      <Loader isLoading={loading} />
    </div>
  );
};
